import axios from "axios";

axios.defaults.withCredentials = true;
export default axios;



// WEBPACK FOOTER //
// ./src/axios.js